import * as constants from './constants';

import axios from '../../common/axios-instance/axios-instance';
import { IUser } from '../../@types';
import { AxiosResponse, AxiosError } from 'axios';
import { push } from 'connected-react-router';
import { Dispatch } from 'redux';

import { ILoginData } from '../../@types';

export interface ILoginSuccess {
  type: constants.LOGIN_SUCCESS;
  payload: string;
}

export interface ILoginFailure {
  type: constants.LOGIN_FAILURE;
  payload: string;
}

export interface ILogoutSuccess {
  type: constants.LOGOUT_SUCCESS;
}

interface ILoginResponse {
  jwtToken: string;
  user: IUser;
}

interface ILoginError extends AxiosError {
  error: {
    response: {
      data?: {
        message?: string;
      };
    };
  };
}

export type LoginAction = ILoginSuccess | ILoginFailure | ILogoutSuccess;

export const login = (loginData: ILoginData) => {
  return (dispatch: Dispatch) => {
    return axios
      .post('/api/user/login', loginData)
      .then((res: AxiosResponse<ILoginResponse>) => {
        if (res.status === 200) {
          dispatch(loginSuccess(res.data.jwtToken));
          const clearStorage = new Date();
          clearStorage.setHours(clearStorage.getHours() + 1);
          localStorage.setItem('token', res.data.jwtToken);
          localStorage.setItem('clearTime', clearStorage.toString());
          localStorage.setItem(
            'crntUser',
            res.data.user.id ? res.data.user.id.toString() : ''
          );
          dispatch(push('/customers'));
        }
      })
      .catch((error: ILoginError) => {
        let errorMessage: string;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        } else {
          errorMessage = 'Login failed';
        }
        dispatch(loginFailure(errorMessage));
      });
  };
};

export const loginSuccess = (jwtToken: string): ILoginSuccess => {
  return {
    type: constants.LOGIN_SUCCESS,
    payload: jwtToken
  };
};

export const loginFailure = (errorMessage: string): ILoginFailure => {
  return {
    type: constants.LOGIN_FAILURE,
    payload: errorMessage
  };
};

export const logout = (path: string) => {
  return (dispatch: Dispatch) => {
    localStorage.clear();
    dispatch(push(path));
    dispatch(logoutSuccess());
    return Promise.resolve(true);
  };
};

export const logoutSuccess = (): ILogoutSuccess => {
  return {
    type: constants.LOGOUT_SUCCESS
  };
};

export const sessionExpired = () => {
  return logout('/session-expired');
};



// WEBPACK FOOTER //
// ./src/modules/login/action.ts